<div class="footer">
  <mat-checkbox>Check me!</mat-checkbox>
</div>
